import { client } from './base';

export function getToken(username: string, password: string): Promise<any> {
    return client.post('/login', {
        username,
        password,
    });
}
